// @flow
import { connect } from 'react-redux'
import ListComponent from './component'
import type { Municipality } from 'sources/types'
import type { AppState } from 'stores'
import { mapActiveMunicipality } from 'components/map/reducer'
import {
  flipSortOrder,
  showLessLines,
  showMoreLines
} from 'components/municipalitySearch/reducer'

function mapStateToProps ({ valuesByMunicipality, filter }: AppState) {
  let sortedList: Array<Municipality> = []
  if (filter.lookupString !== '') {
    const regex = new RegExp(filter.lookupString.split(/,\s*/).join('|'), 'i')
    sortedList = valuesByMunicipality.values().filter(municipality => {
      return regex.test(municipality.Gemeindename)
    })
  } else {
    sortedList = valuesByMunicipality.values()
  }

  sortedList.sort((a: Municipality, b: Municipality) => {
    if (filter.isSortedAscending) {
      return a.Rank - b.Rank
    }
    return b.Rank - a.Rank
  })

  return {
    list:
      filter.lookupString === ''
        ? sortedList.slice(0, filter.numberOfResults)
        : sortedList,
    isSortedAscending: filter.isSortedAscending,
    lookupString: filter.lookupString
  }
}

function mapDispatchToProps (dispatch) {
  return {
    setActiveMunicipalityHandler: (id: number) => {
      dispatch(mapActiveMunicipality(id))
    },
    onIncreaseShownLines: (amount: number) => {
      dispatch(showMoreLines(amount))
    },
    onDecreaseShownLines: (amount: number) => {
      dispatch(showLessLines(amount))
    },
    onFlipSortOrder: () => {
      dispatch(flipSortOrder())
    }
  }
}

export const List = connect(mapStateToProps, mapDispatchToProps)(ListComponent)

export default List



// WEBPACK FOOTER //
// ./src/components/list/container.js